// extracted by mini-css-extract-plugin
export default {"patientDataCategoriesWrapper":"PatientDataCategories_patientDataCategoriesWrapper__m6jGs","patientDataCategoriesList":"PatientDataCategories_patientDataCategoriesList__7y0cW"};